import themeContract from './themeContract.json';

export const NATIVE_THEME_COLOR = themeContract.nativeColor;
